import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlayCircle } from "@fortawesome/free-regular-svg-icons"

import { VideoEmbed, VideoEmbedCanvas } from "./component"

export default {
  id: "video-embed",
  block: {
    category: "Media",
    icon: <FontAwesomeIcon size="3x" icon={faPlayCircle} />,
    label: "Video embed",
  },
  props: [
    {
      name: "title",
      label: "Title",
      type: "text",
      default: {
        iv: "Titre de la vidéo",
        "en-ca": "Video title",
      },
    },
    {
      name: "provider",
      label: "Provider",
      type: "select",
      values: ["youtube", "facebook"],
      default: "youtube",
    },
    {
      name: "videoId",
      label: "YouTube video ID",
      type: "text",
      default: "",
    },
    {
      name: "startSeconds",
      label: "YouTube start time (seconds)",
      type: "text",
      default: "",
    },
    {
      name: "url",
      label: "Facebook video URL",
      type: "text",
      default: "",
    },
    {
      name: "fallbackLabel",
      label: "Fallback link label",
      type: "text",
      default: {
        iv: "Voir la vidéo",
        "en-ca": "Watch the video",
      },
    },
  ],
  component: VideoEmbed,
  canvas: VideoEmbedCanvas,
  components: [],
  styles: {
    position: "relative",
  },
}
